import { SET_THEME, TOGGLE_THEME } from '../actions/themeActions';
import { ThemeType } from '../../models/ThemeType';
import { ThemeState } from '../../shared/types';

const initialState: ThemeState = {
  currentTheme: ThemeType.DARK // Default theme
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case SET_THEME:
      return {
        ...state,
        currentTheme: action.payload
      };
    case TOGGLE_THEME:
      return {
        ...state,
        currentTheme: state.currentTheme === ThemeType.DARK ? ThemeType.LIGHT : ThemeType.DARK
      };
    default:
      return state;
  }
}; 